import { useEffect, useState } from 'react';

function readColorScheme() {
  const html = document.documentElement;


  const dataTheme = html.dataset.theme
  if (dataTheme === 'dark') return 'dark';
  if (dataTheme === 'light') return 'light';

  if(html.classList.contains('dark')){
    return 'dark'
  }

  const savedTheme = localStorage.getItem('theme')

  if(savedTheme === 'light') return 'light'
  if(savedTheme === 'dark') return 'dark'

  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

export function useColorScheme() {
  const [colorScheme, setColorScheme] = useState(readColorScheme);

  useEffect(() => {

    const html = document.documentElement;
    const update = () => setColorScheme(readColorScheme());

    const observer = new MutationObserver(update);

    observer.observe(html, {
      attributes: true,
      attributeFilter: ['class', 'data-theme'],
    });

    const mediaQuery = window.matchMedia?.('(prefers-color-scheme: dark)');
    mediaQuery?.addEventListener?.('change', update);

    window.addEventListener('storage', update)
    window.addEventListener('kit-theme-change', update)

    return () => {
      observer.disconnect();
      mediaQuery?.removeEventListener?.('change', update);
      window.removeEventListener('storage', update)
      window.removeEventListener('kit-theme-change', update)
    };
  }, []);

  return colorScheme;
}
